import React from "react";
import { ENV } from "utils/constants/env";
import { getShortLinkCheckoutUrl, isSetupShortLink } from "utils/shortLink";
import BrowserBezel from "components/BrowserBezel";
import ShortLinkFulfillmentDetails from "components/ShortLinkFulfillmentDetails";
import CheckoutPreview, { IMAGE_DIMENSIONS } from "components/CheckoutPreview";
import TestCheckoutForm, {
  TEST_PAY_CHECKOUT_CONTENT,
  TEST_SETUP_CHECKOUT_CONTENT
} from "components/TestCheckoutForm";
import CodeLinkPreview from "components/CodeLinkPreview";
import { TEST_MODE_BADGE } from "utils/constants/payment";
import classnames from "classnames";
import {
  useCouponPromotionCodes,
  useProductsPrices,
  useTaxRates,
  useIsAuthed,
  useShippingRates
} from "utils/selectors";
import { shortLinkCheckoutPreview } from "components/FormerEditor/common/preview";
import { urlWithCurrentLocationCancel } from "utils/route";

const ShortLinkTestPreview = ({ shortLink }) => {
  const { products, prices } = useProductsPrices();
  const { coupons } = useCouponPromotionCodes();
  const taxRates = useTaxRates();
  const shippingRates = useShippingRates();
  const isAuthed = useIsAuthed();
  const isSetup = isSetupShortLink(shortLink);

  const checkoutPreview = shortLinkCheckoutPreview({
    shortLink,
    products,
    prices,
    coupons,
    taxRates,
    shippingRates
  });
  if (!isAuthed) {
    checkoutPreview.checkout.badge = TEST_MODE_BADGE;
  }

  const liveUrl = getShortLinkCheckoutUrl({
    id: shortLink.short_id,
    mode: ENV.PRODUCTION,
    test: true
  });
  const urlWithCancel = urlWithCurrentLocationCancel(liveUrl);

  const codePreviewProps = {
    href: liveUrl,
    size: 44,
    shortId: shortLink.short_id,
    name: shortLink.title,
    disableTestToggle: true,
    customClasses: {
      container:
        "flex flex-column flex-row-ns justify-between items-center bt hairline-1 pt3"
    }
  };

  const { collapseImages } = checkoutPreview;

  const checkoutFormContent = isSetup
    ? TEST_SETUP_CHECKOUT_CONTENT
    : TEST_PAY_CHECKOUT_CONTENT;

  return (
    <BrowserBezel copy={liveUrl} href={urlWithCancel}>
      <div className="flex flex-column flex-row-l">
        <div
          className="w-100 w-50-l pa3 pa4-l bb bn-l hairline-1"
          style={{ backgroundColor: "#FCFCFC" }}
        >
          <CheckoutPreview
            collapseImages={collapseImages}
            {...checkoutPreview.checkout}
          />
          <div className="w-100 dib flex flex-row">
            {!collapseImages ? <div style={IMAGE_DIMENSIONS}></div> : null}
            <div
              className={classnames("w-100 bt hairline-1", {
                ml3: !collapseImages
              })}
            >
              <ShortLinkFulfillmentDetails data={shortLink} />
            </div>
          </div>
          {isAuthed && (
            <div className="pt3">
              <CodeLinkPreview {...codePreviewProps} />
            </div>
          )}
        </div>
        <div className="w-100 w-50-l pa3 pa4-l bl-l hairline-1 flex flex-column">
          <TestCheckoutForm liveUrl={urlWithCancel} {...checkoutFormContent} />
        </div>
      </div>
    </BrowserBezel>
  );
};

export default ShortLinkTestPreview;
